import {
  Box,
  Button,
  ButtonBase,
  Checkbox,
  IconButton,
  InputAdornment,
  makeStyles,
  TextField,
  Typography,
} from '@material-ui/core';
import React from 'react';
import { Dot } from 'react-animated-dots';
import { apiGet } from 'services/api';
import SearchIcon from '@material-ui/icons/Search';
import { FormControl } from 'util/FormControl';
import DynamicIcon from './DynamicIcon';

const viewProfiles = {
  location: {
    title: 'title',
    subtitle: 'address',
  },
  local: {
    title: 'title',
    subtitle: 'subtitle',
  },
  table: {
    title: 'title',
    subtitle: 'subtitle',
  },
};

const useStyles = makeStyles((theme) => ({
  focusedOption: {
    border: '1px solid #233C97',
  },
}));
export const SearchBlock = ({ ...props }) => {
  let popperReference = React.useRef({ current: {} });
  const classes = useStyles();
  const [searchResults, setSearchResults] = React.useState(
    props.selection || []
  );
  const [localSearchString, setLocalSearchString] = React.useState('');
  const [searching, setSearching] = React.useState(false);
  const [typing, setTyping] = React.useState(false);
  const lastUpdated = React.useRef({ current: { time: Date.now() } });
  const debounceHandler = React.useRef({ current: {} });
  const typingInterval = props.isAsyncSearch ? 1000 : 0;

  React.useEffect(() => {
    props.selection && setSearchResults(props.selection);
    setLocalSearchString('');
  }, [props.selection]);

  const bouncer = () => {
    if (Date.now() - lastUpdated.current.time >= typingInterval) {
      setTyping(true);
      props.isAsyncSearch && setSearching(true);
      (
        props.searchPreProcessor ||
        ((completedCallback) => completedCallback({}))
      )(
        (result) => {
          props.queryFunction(
            debounceHandler.current.searchString,
            searchResults,
            (list) => {
              setSearchResults(list);
              setSearching(false);
            },
            result
          );
        },
        () => {
          setSearching(false);
        }
      );
      clearInterval(debounceHandler.current.typingInterval);
      setTyping(false);
    }
  };

  const handleSearchType = (event) => {
    setLocalSearchString(event.target.value);
    debounceHandler.current.searchString = event.target.value;
    lastUpdated.current.time = Date.now();
    if (!typing) {
      debounceHandler.current.typingInterval = setInterval(
        bouncer,
        typingInterval
      );
    }
    setTyping(true);
  };

  const [navigationIndex, setNavigationIndex] = React.useState(-1);
  const handleKey = (e) => {
    switch (e.key) {
      case 'ArrowDown':
        if (
          props.searchResults &&
          navigationIndex < props.searchResults.length - 1
        ) {
          setNavigationIndex(navigationIndex + 1);
          navigationIndex > -1 &&
            popperReference.current &&
            popperReference.current.scrollBy(0, 40);
        } else if (
          props.searchResults &&
          navigationIndex === props.searchResults.length - 1
        ) {
          setNavigationIndex(0);
          popperReference.current &&
            popperReference.current.scrollBy(
              0,
              -1 * popperReference.current.scrollHeight
            );
        }
        break;
      case 'ArrowUp':
        if (props.searchResults && navigationIndex > 0) {
          setNavigationIndex(navigationIndex - 1);
          popperReference.current && popperReference.current.scrollBy(0, -40);
        } else if (props.searchResults && navigationIndex === 0) {
          setNavigationIndex(props.searchResults.length - 1);
          popperReference.current &&
            popperReference.current.scrollBy(
              0,
              popperReference.current.scrollHeight
            );
        }
        break;
      case 'Enter':
        if (props.searchResults && navigationIndex !== -1) {
          (props.onSelect || (() => {}))(props.searchResults[navigationIndex]);
          setNavigationIndex(-1);
        }
        break;
    }
  };
  React.useEffect(() => {
    props.searchPopper && window.addEventListener('keydown', handleKey);
    return () => window.removeEventListener('keydown', handleKey);
  }, [navigationIndex]);

  return (
    <Box>
      <div
        style={{
          ...(!props.handleSearchType
            ? {
                borderBottom: '1px solid #e5e5e5',
                padding: 10,
                paddingBottom: 0,
              }
            : {}),
          position: 'sticky',
          top: 0,
          background: '#ffffff',
          zIndex: 1,
        }}
      >
        {!props.handleSearchType && (
          <TextField
            value={localSearchString}
            autoFocus={!props.isMobile && true}
            placeholder="Search"
            onChange={handleSearchType}
            InputProps={{
              disableUnderline: true,
              startAdornment: (
                <InputAdornment>
                  <SearchIcon
                    style={{
                      color: '#949494',
                      fontSize: 20,
                      marginTop: -3,
                    }}
                  />
                </InputAdornment>
              ),
            }}
            size="small"
            style={{
              width: '100%',
              backgroundColor: '#f5f5f5',
              padding: '10px 10px 5px 10px',
              borderRadius: 7,
            }}
          />
        )}
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: '5px 0px',
            margin: '5px 0px',
          }}
        >
          {props.multiselect && (
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <ButtonBase onClick={props.selectAllHandle}>
                <Checkbox
                  color="primary"
                  style={{ padding: 0 }}
                  checked={props.checkSelectAll()}
                />
                <Typography
                  style={{
                    fontSize: '0.8rem',
                    color: props.checkSelectAll() ? '#b70000' : '#7467F0',
                    margin: '0px 5px 0px 5px',
                  }}
                >
                  {props.checkSelectAll() ? 'Deselect all' : 'Select all'}
                </Typography>
              </ButtonBase>
            </div>
          )}
        </div>
      </div>
      <div style={{ padding: 10 }}>
        {props.searching || searching ? (
          <div
            style={{
              width: '100%',
            }}
          >
            <div
              style={{
                color: '#909090',
                textAlign: 'center',
                letterSpacing: 1,
              }}
            >
              <h3>
                Loading
                <Dot>.</Dot>
                <Dot>.</Dot>
                <Dot>.</Dot>
              </h3>
            </div>
          </div>
        ) : (props.searchResults && props.searchResults.length > 0) ||
          (searchResults && searchResults.length > 0) ? (
          <div
            ref={popperReference}
            style={{
              width: '100%',
              overflow: 'auto',
              maxHeight: props.isSmallScreen ? 'calc( 50vh - 88px)' : 500,
            }}
          >
            {(props.searchResults || searchResults || []).map((item, index) => (
              <div style={{ width: '100%' }}>
                <ButtonBase
                  focusVisibleClassName={classes.focusedOption}
                  style={{
                    width: '100%',
                  }}
                  onClick={() => props.onSelect(item)}
                >
                  <div
                    style={{
                      width: '100%',
                      textAlign: 'left',
                      display: 'flex',
                      background: index === navigationIndex && '#e8e8e888',
                    }}
                  >
                    {props.multiselect && (
                      <div style={{ width: 25 }}>
                        <Checkbox
                          color="primary"
                          style={{ padding: '5px 0px 0px' }}
                          checked={(props.checkSelected || (() => false))(item)}
                        />
                      </div>
                    )}
                    {item[
                      (viewProfiles[props.searchType] || {}).iconId || 'iconId'
                    ] && (
                      <div style={{ margin: 8 }}>
                        <DynamicIcon
                          iconId={
                            item[
                              (viewProfiles[props.searchType] || {}).iconId ||
                                'iconId'
                            ]
                          }
                        />
                      </div>
                    )}
                    <div style={{ width: '100%' }}>
                      <Typography
                        style={{
                          color: '#505050',
                          fontSize: 17.5,
                          margin:
                            props.searchType === 'table'
                              ? '5px 5px 0px 5px'
                              : '5px 5px 5px 5px',
                        }}
                      >
                        {
                          item[
                            (viewProfiles[props.searchType] || {}).title ||
                              'title'
                          ]
                        }
                      </Typography>
                      {item[
                        (viewProfiles[props.searchType] || {}).subtitle ||
                          'subtitle'
                      ] && (
                        <Typography
                          noWrap={props.searchType === 'location'}
                          style={{
                            color: '#909090',
                            fontSize: 12.5,
                            padding:
                              props.searchType === 'table'
                                ? '0px 20px 5px 5px'
                                : '0px 20px 10px 5px',
                            maxWidth: props.searchType === 'location' && '100%',
                            textOverflow:
                              props.searchType === 'location' && 'ellipsis',
                          }}
                        >
                          {
                            item[
                              (viewProfiles[props.searchType] || {}).subtitle ||
                                'subtitle'
                            ]
                          }
                        </Typography>
                      )}
                    </div>
                  </div>
                </ButtonBase>
              </div>
            ))}
          </div>
        ) : (
          <div
            style={{
              width: '100%',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            {props.emptyResults ? (
              <>
                <Typography
                  style={{
                    marginBottom: 8,
                  }}
                >
                  {props.emptyResults.message &&
                    props.emptyResults.message
                      .split('\n')
                      .map((str) => (
                        <p style={{ margin: 0, padding: 0 }}>{str}</p>
                      ))}
                </Typography>
                <Button
                  style={{
                    marginBottom: 24,
                  }}
                  variant="contained"
                  color="primary"
                  onClick={() => {
                    props.emptyResults.deeplink &&
                      props.emptyResultsHandler(
                        props.emptyResults.deeplink,
                        props.emptyResults.apiType
                      );
                  }}
                >
                  {props.emptyResults.buttonText}
                </Button>
              </>
            ) : (
              <Typography>No Results</Typography>
            )}
          </div>
        )}
      </div>
    </Box>
  );
};
